import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { RequestService } from 'src/app/services/request.service';
import { ModalDialog } from 'src/app/Modal/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Project } from 'src/app/models/project.model';
import { dynamicLocaleCompareWithOptions } from 'src/app/helper/sortFunctions';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.css']
})
export class ProjectListComponent implements OnInit, OnDestroy {
  // Properties
  private unscubscribe$ = new Subject<void>();
  displayedColumns: string[];
  dataSource = new MatTableDataSource;

  project = {
    title: 'Project List', addButton: 'Add New Project',
    col1Titel: 'Project Name', col2Titel: 'Project Description', col3Titel: 'Created On', col4Titel: 'Last Edited On', col5Titel: 'Actions',
    action1: 'Edit Project', action2: 'Waggon List', action3: 'Delete Project', action4: 'Train List',
    deleteDialog: 'Do You Really Want To Delete This Project?'
  }

  // Ctor
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private requestService: RequestService,
    private authService: AuthService
  ) { }

  // Lifecycle Hooks
  ngOnInit() {
    this.displayedColumns = ['projectName', 'projectDescription', 'projectCreateDate', 'projectLastEditDate', 'projectActions'];
    this.loadProjects();
  }

  // Methods
  openCellEdit(projectId: number): void {
    this.router.navigate(['project/edit', projectId]);
  }

  createProject() {
    this.router.navigate(['project/edit', -1]);
  }

  showDeleteDialog(projectId: number): void {
    const dialogRef = this.dialog.open(ModalDialog, {
      data: {
        title: 'Warning',
        message: this.project.deleteDialog,
        showCancel: true,
        cancelButtonText: 'Cancel',
        saveButtonText: 'Okay'
      }
    });

    dialogRef.afterClosed()
      .subscribe(result => {
        if (result) {
          this.deleteProject(projectId);
        } else {
          // do nothing just close the modal
        }
      });
  }

  deleteProject(projectId: number) {
    this.requestService.deleteProject(projectId)
      .pipe(takeUntil(this.unscubscribe$))
      .subscribe((next: Project[]) => {
        this.setProjectList(next);
      });
  }

  loadProjects() {
    this.requestService.getProjects(this.authService.getCurrentCompanyId())
      .pipe(takeUntil(this.unscubscribe$))
      .subscribe(resp => {
        this.setProjectList(resp);
      });
  }

  setProjectList(projectList: Project[]) {
    if (projectList) {
      this.dataSource.data = projectList.sort((a, b) => dynamicLocaleCompareWithOptions(a, b, 'name'));
    } else {
      this.dataSource.data = [];
    }
  }

  openWagonTypeList(projectId: number) {
    this.router.navigate(['wagon/list', projectId]);
  }
  openTrainList(projectId: number) {
    this.router.navigate(['train/list', projectId]);
  }

  ngOnDestroy(): void {
    this.unscubscribe$.next();
    this.unscubscribe$.complete();
  }
}